module.exports = __webpack_public_path__ + "assets/img/en-9f2ee006.png";